import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const TermsOfService = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-background to-primary/5">
      <div className="container max-w-4xl py-12 px-4">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-8"
        >
          ← Powrót
        </Button>

        <h1 className="text-4xl font-bold mb-8 text-primary">
          Regulamin Serwisu lifactor.com
        </h1>

        <div className="prose prose-slate max-w-none space-y-8 leading-relaxed text-foreground">
          {/* Section 1 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              1. Postanowienia ogólne
            </h2>
            <p className="text-muted-foreground">
              Niniejszy Regulamin określa zasady korzystania z serwisu lifactor.com. 
              Korzystanie z serwisu oznacza akceptację wszystkich postanowień Regulaminu.
            </p>
            <p className="text-muted-foreground">
              Serwis lifactor.com jest prowadzony przez administratora, z którym można 
              skontaktować się pod adresem e-mail: miloxiads(at)gmail.com
            </p>
          </section>

          {/* Section 2 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              2. Definicje
            </h2>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>
                <strong>Serwis</strong> – strona internetowa lifactor.com wraz z wszystkimi 
                podstronami i funkcjonalnościami
              </li>
              <li>
                <strong>Administrator</strong> – podmiot zarządzający serwisem lifactor.com
              </li>
              <li>
                <strong>Użytkownik</strong> – osoba korzystająca z serwisu
              </li>
              <li>
                <strong>Usługa</strong> – wszelkie funkcjonalności dostępne w serwisie, 
                w tym audyty, raporty i formularze
              </li>
            </ul>
          </section>

          {/* Section 3 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              3. Warunki korzystania z serwisu
            </h2>
            <p className="text-muted-foreground">
              Korzystanie z serwisu jest dobrowolne i bezpłatne, chyba że wskazano inaczej 
              przy konkretnej usłudze.
            </p>
            <p className="text-muted-foreground">
              Użytkownik zobowiązuje się do korzystania z serwisu w sposób zgodny z prawem, 
              dobrymi obyczajami oraz niniejszym Regulaminem.
            </p>
            <p className="text-muted-foreground">
              Zabrania się podawania nieprawdziwych informacji oraz podejmowania działań 
              mogących zakłócić funkcjonowanie serwisu.
            </p>
          </section>

          {/* Section 4 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              4. Usługi świadczone przez serwis
            </h2>
            <p className="text-muted-foreground">
              Serwis oferuje m.in.:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Audyty i analizy związane z social sellingiem</li>
              <li>Generowanie raportów i rekomendacji</li>
              <li>Dostęp do materiałów edukacyjnych</li>
              <li>Możliwość kontaktu z administratorem poprzez formularze</li>
            </ul>
            <p className="text-muted-foreground">
              Administrator zastrzega sobie prawo do modyfikacji, zawieszenia lub zaprzestania 
              świadczenia usług bez wcześniejszego powiadomienia.
            </p>
          </section>

          {/* Section 5 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              5. Odpowiedzialność
            </h2>
            <p className="text-muted-foreground">
              Administrator dokłada wszelkich starań, aby serwis działał prawidłowo, jednak 
              nie gwarantuje nieprzerwanego i bezbłędnego funkcjonowania.
            </p>
            <p className="text-muted-foreground">
              Administrator nie ponosi odpowiedzialności za:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
              <li>Decyzje biznesowe podjęte na podstawie treści serwisu</li>
              <li>Problemy techniczne wynikające z używanego sprzętu lub oprogramowania użytkownika</li>
              <li>Treści zewnętrzne linkowane z serwisu</li>
              <li>Utratę danych wynikającą z przyczyn niezależnych od administratora</li>
            </ul>
          </section>

          {/* Section 6 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              6. Prawa autorskie
            </h2>
            <p className="text-muted-foreground">
              Wszystkie treści zamieszczone w serwisie, w tym teksty, grafiki, loga, zdjęcia, 
              są własnością administratora lub zostały użyte za zgodą właściciela praw.
            </p>
            <p className="text-muted-foreground">
              Kopiowanie, rozpowszechnianie lub inne wykorzystywanie treści bez zgody 
              administratora jest zabronione.
            </p>
          </section>

          {/* Section 7 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              7. Ochrona danych osobowych
            </h2>
            <p className="text-muted-foreground">
              Zasady przetwarzania danych osobowych określa{" "}
              <a href="/polityka-prywatnosci" className="text-primary hover:underline">
                Polityka Prywatności
              </a>
              .
            </p>
            <p className="text-muted-foreground">
              Administrator przetwarza dane zgodnie z obowiązującymi przepisami prawa, 
              w szczególności z RODO.
            </p>
          </section>

          {/* Section 8 */}
          <section className="space-y-4">
            <h2 className="text-2xl font-semibold text-primary">
              8. Postanowienia końcowe
            </h2>
            <p className="text-muted-foreground">
              Administrator zastrzega sobie prawo do zmiany Regulaminu. Zmiany wchodzą w życie 
              z chwilą ich opublikowania w serwisie.
            </p>
            <p className="text-muted-foreground">
              W sprawach nieuregulowanych Regulaminem stosuje się przepisy prawa polskiego.
            </p>
            <p className="text-muted-foreground">
              W razie pytań dotyczących Regulaminu prosimy o kontakt: miloxiads(at)gmail.com
            </p>
          </section>

          {/* Footer info */}
          <section className="pt-8 border-t">
            <p className="text-sm text-muted-foreground">
              Regulamin obowiązuje od 2025 roku.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
